import { FieldContext, FieldLocator, isFuzzyValueField } from '@app/common/configurable-wizards';
import { FuzzyValueFieldComponent } from '@app/common/configurable-wizards/fields/FuzzyValueField';

export const isAmountOfLastDepositFieldInfoLocator = (fieldContext: FieldContext) => (
  isFuzzyValueField(fieldContext.field)
  && fieldContext.field.id === 'AmountOfLastDeposit'
);

export const AmountOfLastDepositFieldInfoLocator: FieldLocator = (context) => (
  isAmountOfLastDepositFieldInfoLocator(context)
    ? FuzzyValueFieldComponent
    : undefined
);
